import { render, staticRenderFns } from "./PublicRelations.vue?vue&type=template&id=854edce2&"
import script from "./PublicRelations.vue?vue&type=script&lang=js&"
export * from "./PublicRelations.vue?vue&type=script&lang=js&"
import style0 from "./PublicRelations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports